import React from 'react';
import View from "./view";
import Page from "src/components/Page";
import useMediaQuery from "@mui/material/useMediaQuery";

function Index(props) {
    localStorage.removeItem("@storeAuctionLot");
    const isDesktop = useMediaQuery("(min-width:1000px)");
   
    return (
        <Page>
            
            <div style={{ 
                paddingLeft: isDesktop ? "8%" : "20px", 
                paddingRight: isDesktop ? "8%" : "20px",
                paddingTop: isDesktop ? "40px" : "20px",
                paddingBottom: "100px",
                maxWidth: "1800px", // Limit para hindi masyadong banat sa ultra-wide monitors
                margin: "0 auto"    // Center ang buong content
            }}>
                <View />
            </div>
        </Page>
    );
}

export default Index;